module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('ul', {
    staticClass: "footer_list"
  }, _vm._l((_vm.aboutus), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: item.href,
          params: {
            liName: item.liName
          }
        }
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('p', [_vm._v("Copyright @ 2015-2019 www.qiyewan.com 上海知加信息科技有限公司")]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/#/Integrated/index",
      "target": "_blank"
    }
  }, [_vm._v("备案号：沪ICP备15043250号-2")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6acf5efa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 1042
// module chunks = 40